var map = {
	"./app-icon.svg": 1704,
	"./caret-right-icon.svg": 1705,
	"./chrome-icon.webp": 1706,
	"./edge-icon.webp": 1707,
	"./firefox-icon.webp": 1708,
	"./opera-icon.webp": 1709,
	"./safari-icon.webp": 1710,
	"./unknown-icon.webp": 1711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1703;